export default __webpack_public_path__ + "static/media/paraEmpresas_04.d3f2509a.svg";